export const Login = accessToken => ({
  type: '@risa/LOGIN',
  access_token: accessToken
})

export const Logout = () => ({
  type: '@risa/LOGOUT'
})
